// src/shared/utils/event-bus.ts
export enum BaseEventKeys {
  error = 'error',
  success = 'success', // Aggiungiamo l'evento success
}

export interface BaseEvents {
  [BaseEventKeys.error]: Error;
  [BaseEventKeys.success]: void; // Success può contenere un messaggio o qualunque cosa tu preferisca
}
